import { render, staticRenderFns } from "./DailyBriefing.vue?vue&type=template&id=becbe324&scoped=true&"
import script from "./DailyBriefing.vue?vue&type=script&lang=js&"
export * from "./DailyBriefing.vue?vue&type=script&lang=js&"
import style0 from "./DailyBriefing.vue?vue&type=style&index=0&id=becbe324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becbe324",
  null
  
)

export default component.exports